import CryptoJS from "crypto-js";

const SECRET = process.env.REACT_APP_CRYPTO_SECRET;
const key = CryptoJS.SHA256(SECRET);
const iv = CryptoJS.enc.Hex.parse("00000000000000000000000000000000");

// 🔐 SAVE (ENCRYPT)
export const setSecureItem = (keyName, value) => {
  const encrypted = CryptoJS.AES.encrypt(
    JSON.stringify(value),
    key,
    { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
  );

  localStorage.setItem(keyName, encrypted.toString());
};

// 🔓 GET (DECRYPT)
export const getSecureItem = (keyName) => {
  const data = localStorage.getItem(keyName);
  if (!data) return null;

  try {
    const bytes = CryptoJS.AES.decrypt(data, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (err) {
    console.error("❌ Local decrypt failed:", err);
    return null;
  }
};

export const encryptPayload = (data) => {
  const encrypted = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    key,
    { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
  );

  return { data: encrypted.toString() };
};

export const decryptPayload = (payload) => {
  const bytes = CryptoJS.AES.decrypt(payload.data, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};